import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { mensalidade_media, mensalidade_media_rede } from "../../services/api";

const Mensalidade_media = (props) => {
    const [data2, setData2] = useState([]);
    const [dataR, setDataR] = useState([]);

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha', 'Freguesia', 'Recreio'];

    let data_inicio = props.di;
    let data_fim = props.df;

    const fetchData = async () => {
        try {
            // Mantendo os parâmetros fixos conforme o original
            const response = await mensalidade_media('2026-08-28', '2027-03-31');
            setData2(response);

            const responseR = await mensalidade_media_rede('2026-08-28', '2027-03-31');
            setDataR(responseR);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [data_inicio, data_fim]);

    // Funções auxiliares para formatação (substituindo os formatters do Google Charts)
    const formatCurrency = (value) => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(value);
    };

    const formatPercent = (value) => {
        if (!Number.isFinite(value)) return "-";
        return `${value.toFixed(2).replace('.', ',')} %`;
    };

    const getVariationStyle = (value) => {
        if (value < 0) return { backgroundColor: "red", color: "white" };
        if (value >= 0 && value < 1) return { backgroundColor: "orange", color: "white" };
        if (value >= 1 && value < 3) return { backgroundColor: "blue", color: "white" };
        if (value >= 3) return { backgroundColor: "green", color: "white" };
        return {};
    };

    // Estruturando os dados como objetos para facilitar o mapeamento
    let processedData = [];

    if (data2 && data2.length > 0) {
        processedData = data2.map((item) => {
            const mma27 = parseFloat(item.mma27 || 0);
            const mma26 = parseFloat(item.mma26 || 0);
            const variacao = ((mma27 * 100) / mma26) - 100;

            return {
                unidade: unidades[parseInt(item.sec)],
                mma27,
                mma26,
                variacao
            };
        });

        // Ordenação alfabética pelas unidades
        processedData.sort((a, b) => a.unidade.localeCompare(b.unidade));
    }

    if (dataR && dataR.length > 0) {
        const mma26R = parseFloat(dataR[0].mma26 || 0);
        const mma27R = parseFloat(dataR[0].mma27 || 0);
        const variacaoR = ((mma27R * 100) / mma26R) - 100;

        // Adiciona os dados gerais da Rede ao final da tabela
        processedData.push({
            unidade: dataR[0].rede || "Rede",
            mma27: mma27R,
            mma26: mma26R,
            variacao: variacaoR
        });
    }

    if (processedData.length > 0) {
        return (
            <div className="media">
                <h5>Mensalidades médias</h5>
                <Table striped bordered hover responsive size="sm" className="mt-3">
                    <thead>
                        <tr>
                            <th>Unidade</th>
                            <th>2027</th>
                            <th>2026</th>
                            <th>Aumento %</th>
                        </tr>
                    </thead>
                    <tbody>
                        {processedData.map((row, index) => (
                            <tr key={index}>
                                <td>{row.unidade}</td>
                                <td style={row.mma27 < 0 ? { color: 'red' } : {}}>
                                    {formatCurrency(row.mma27)}
                                </td>
                                <td style={row.mma26 < 0 ? { color: 'red' } : {}}>
                                    {formatCurrency(row.mma26)}
                                </td>
                                <td style={getVariationStyle(row.variacao)}>
                                    {formatPercent(row.variacao)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        );
    } else {
        return (
            <div className="media">
                <h5>Mensalidades médias</h5>
                <p>Aguardando o banco de dados.</p>
            </div>
        );
    }
}

export default Mensalidade_media;